/* eslint-env browser */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'redux-router';

import auth from 'lib/Auth';

import { setHeader, loadMyTrips } from 'actions';

import Loading from 'components/common/Loading';
import MyTripsList from 'components/calendar/MyTripsList';
import MyTripsListItem from 'components/calendar/MyTripsListItem';

class MyTripsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.getTitle = this.getTitle.bind(this);
    this.renderMyTripsListItem = this.renderMyTripsListItem.bind(this);
  }

  componentWillMount() {
    this.props.loadMyTrips();
    this.updateHeader(this.props);
  }

  componentWillReceiveProps(nextProps) {
    // this.props.loadMyTrips();
    // this.updateHeader(nextProps);
  }

  componentDidUpdate() {
  }

  getTitle() {
    return 'My Trips';
  }

  updateHeader(props) {

    const headerTitle = this.getTitle();

    this.props.setHeader(headerTitle);

  }

  renderMyTripsListItem(myTrip, drawDivider = false) {

    let onSelect = (selectedMyTrip) => { window.open( auth.getAuthURL(selectedMyTrip.dispatch), '_blank' ); };

    return (
      <MyTripsListItem
        drawDivider={drawDivider}
        showChevron
        myTrip={myTrip}
        key={`${myTrip.id}`}
        onSelect={onSelect}
      />
   );
  }

  render() {
    if (this.props.isLoading) {
      return (
        <Loading withWrapper />
      );
    }

    return (
      <section className="myTrips-section">
        <MyTripsList
          myTripsData={this.props.myTripsData}
          isLoading={this.props.isLoading}
          renderItem={this.renderMyTripsListItem}
        />
      </section>
    );
  }
}

function mapStateToProps(state) {
  const { myTrips } = state;
  const { myTripsData, isLoading } = myTrips;

  return {
    isLoading,
    myTripsData
  };
}

export default connect(mapStateToProps, {
  setHeader,
  loadMyTrips,
  push,
})(MyTripsPage);



// WEBPACK FOOTER //
// ./src/app/containers/MyTripsPage.js